<div *ngIf="mode === 'border'" class="border"></div>
<ng-content></ng-content>
